import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface CommonState {
  isLoading: boolean;
}

const initialState: CommonState = {
  isLoading: false,
};

const commonSlice = createSlice({
  name: 'Common',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      return { ...state, isLoading: action.payload };
    },
  },
});

export const selectLoading = createSelector(
  (state: RootState) => state.commonReducer,
  (commonReducer: CommonState) => commonReducer.isLoading,
);

export const { setLoading } = commonSlice.actions;

export default commonSlice.reducer;
